import { ArrowUpCircleOutlineIcon } from './ArrowUpCircleOutlineIcon';

/**
 * author: Austin Andrews
 * id D41B6302-5A2E-4B55-93A4-E30E07F761C1
 * name arrow-up-circle-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-circle-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowTopCircleOutlineIcon = ArrowUpCircleOutlineIcon;
export default ArrowTopCircleOutlineIcon